export const cardStyles = {
  base: `
    bg-white
    rounded-xl
    border border-gray-200
    transition-all duration-300
    shadow-card
  `,
  
  variants: {
    default: '',
    
    glass: `
      bg-white/70
      backdrop-blur-lg
      border-white/20
    `,
    
    gradient: `
      bg-gradient-to-br from-primary-50 to-white
      border-primary-100
    `,
    
    elevated: `
      shadow-lg
    `,
    
    outlined: `
      shadow-none
      border-2
    `,
  },
  
  padding: {
    none: 'p-0',
    sm: 'p-3',
    md: 'p-6',
    lg: 'p-8',
  },
  
  hoverable: `
    hover:shadow-card-hover
    hover:-translate-y-1
    cursor-pointer
  `,
};